export default __webpack_public_path__ + "static/media/pet_4.1b373929.png";